import { Col, Layout, Result, Row } from 'antd';
import React from 'react';
import { Navigate } from 'react-router-dom';

class ControllerPage403 extends React.Component {
  state = {
    _navigate: false,
  };

  onButton = () => {
    this.setState({ _navigate: true });
  };

  render = () => {
    const { Content } = Layout;

    if (this.state._navigate) {
      return <Navigate to="/" />;
    }

    return (
      <Content>
        <Row justify="center" style={{ height: '100vh', alignItems: 'center' }}>
          <Col span={24}>
            <Result
              status="403"
              subTitle="Desculpe, você não tem autorização para acessar essa página."
              title="403"
            />
          </Col>
        </Row>
      </Content>
    );
  };
}

export default ControllerPage403;
